export const RAW_EMAIL = "EmailMessage::raw";
